import { render, staticRenderFns } from "./dictionary-manage.vue?vue&type=template&id=3007d510&scoped=true"
import script from "./dictionary-manage.vue?vue&type=script&lang=js"
export * from "./dictionary-manage.vue?vue&type=script&lang=js"
import style0 from "./dictionary-manage.vue?vue&type=style&index=0&id=3007d510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3007d510",
  null
  
)

export default component.exports